import React from 'react';
import { Settings } from '@material-ui/icons';
import { IconButton, Menu, MenuItem, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function SettingsMenu({ component, button }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { t, i18n } = useTranslation();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {button ? (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {t('settings-language')}
            <Button onClick={handleMenu} variant="outlined">
              {i18n.language}
            </Button>
          </div>
        </>
      ) : (
        <IconButton
          style={{ color: '#fff' }}
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}>
          <Settings />
        </IconButton>
      )}
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={open}
        onClose={handleClose}>
        <MenuItem onClick={handleClose}>{component}</MenuItem>
      </Menu>
    </div>
  );
}
